module.exports = __webpack_public_path__ + "img/dsci0111.ce78ffcc.jpg";